module.exports = __webpack_public_path__ + "static/money_out-5690a61788f6fa2e45d289f9679461a4.svg";